import { Styles, View } from '@react-pdf/renderer';

import { PropsWithChildren } from 'react';

export const FlexRow = ({
  children,
  alignItems = 'center',
  gap = 0,
}: PropsWithChildren<{
  alignItems?: Styles[string]['alignItems'];
  gap?: Styles[string]['gap'];
}>) => (
  <View
    style={{
      display: 'flex',
      flexDirection: 'row',
      alignItems,
      gap,
    }}
  >
    {children}
  </View>
);
